import { render, staticRenderFns } from "./SectionAgencyLegalInformationOkved.vue?vue&type=template&id=d8e2a4b2&"
import script from "./SectionAgencyLegalInformationOkved.vue?vue&type=script&lang=js&"
export * from "./SectionAgencyLegalInformationOkved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports